module.exports = __webpack_public_path__ + "img/banner.cb923ac.jpg";